import { QueryApiService } from 'src/common/api-service';
import { AuditableEntity } from '../common';
import { JobSkill } from './job-skills-api';
import { JobRole } from './job-roles-api';

export interface JobRoleJobSkill extends AuditableEntity<string> {
  skillId: string;
  skill: JobSkill;
  roleId: string;
  role: JobRole;
  order?: number;
}

export class JobRoleJobSkillApiService extends QueryApiService<JobRoleJobSkill> {
  constructor() {
    super('jobRolesJobSkills');
  }
}
